import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmark = (props, ref) => /* @__PURE__ */ React.createElement("svg", { height: "current", viewBox: "0 0 16 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 7L5 11L15 1", stroke: "current", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCheckmark);
export default ForwardRef;
